import type { ConnectedFacility } from '../../../../../js/api';
import { QueueCodes } from '../../../constants/workflows';

type Props = {
  connectionsPendingProviderResponse: ConnectedFacility[];
};

export function ConnectionsPendingProviderResponse({ connectionsPendingProviderResponse }: Props) {
  if (connectionsPendingProviderResponse.length === 0) {
    return null;
  }

  if (connectionsPendingProviderResponse.length > 1) {
    const handleClick = () => {
      window.location.href = '/app/provider/connections';
    };

    return (
      <div
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleClick();
          }
        }}
        className="tw:bg-warning-section-bg tw:rounded-xl tw:p-4 tw:border tw:border-orange-300/20 tw:hover:bg-orange-300/20 tw:transition-colors tw:cursor-pointer"
      >
        <div className="tw:flex tw:items-start tw:gap-3">
          <div className="tw:w-10 tw:h-10 tw:sm:w-12 tw:sm:h-12 tw:shrink-0 tw:bg-warning-section-text tw:rounded-full tw:flex tw:items-center tw:justify-center">
            <i className="fa-solid fa-fw fa-handshake tw:text-white tw:text-base tw:sm:text-lg" />
          </div>
          <div className="tw:flex-col">
            <div className="tw:font-medium tw:text-warning-section-text tw:hover:underline">
              {connectionsPendingProviderResponse.length} New Connection Requests
            </div>
            <div className="tw:text-sm tw:text-zinc-700">Click here to view and respond</div>
          </div>
        </div>
      </div>
    );
  }

  const connection = connectionsPendingProviderResponse[0];
  const facilityName =
    connection.facility?.name || connection.healthcare_entity?.name || 'Unknown Facility';

  const handleClick = () => {
    window.location.href = `/app/provider/connections/queue=${QueueCodes.NEEDS_RESPONSE}&id=${connection.id}`;
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleClick();
        }
      }}
      onClick={handleClick}
      className="tw:bg-warning-section-bg  tw:rounded-xl tw:p-4 tw:border tw:border-orange-300/20 tw:hover:bg-orange-300/20 tw:transition-colors tw:cursor-pointer"
    >
      <div className="tw:flex tw:items-start tw:gap-3">
        <div className="tw:w-10 tw:h-10 tw:sm:w-12 tw:sm:h-12 tw:shrink-0 tw:bg-warning-section-text tw:rounded-full tw:flex tw:items-center tw:justify-center">
          <i className="fa-solid fa-fw fa-handshake tw:text-white tw:text-base tw:sm:text-lg" />
        </div>
        <div className="tw:flex-col">
          <div className="tw:font-medium tw:text-warning-section-text tw:hover:underline">
            Click to View Connection Request
          </div>
          <div className="tw:text-sm">{facilityName} wants to connect.</div>
        </div>
      </div>
    </div>
  );
}

export default ConnectionsPendingProviderResponse;
